<avi-bar-graph
    [dataset]="trafficLogsGraphStore.graphBarData$ | async"
    [graphEndTimestamp]="trafficLogsGraphStore.end$ | async"
    [graphStartTimestamp]="trafficLogsGraphStore.start$ | async"
    [onUserInteractionWithGraphOptionsSubject]="trafficLogsGraphStore.startLoadingSubject"
    (onOverlayCreationOrModificationOrDeletion)="trafficLogsStore.setTableCustomTimeframe($event)"
    (clickOverlayZoom)="trafficLogsStore.setGraphCustomTimeframe()"
    [colorLegend$]="trafficLogsGraphStore.currentGraphColorsLegend$"
    tooltipTotalLabelAddendum="{{ tooltipLogsLabel }}"
    [isLoading]="trafficLogsGraphStore.isLoading$ | async"
    [hasError]="trafficLogsGraphStore.hasError$ | async"
    [isGraphApiLoopInProgress]="trafficLogsStore.isGraphApiLoopInProgress$ | async"
    [makeEdgeBarsUniformWidth]="true"
></avi-bar-graph>
